module.exports = __webpack_public_path__ + "b7b49c627d31fc1b3d412a602deac8e5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-3.png
// module id = 1747
// module chunks = 0